var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.6 40.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#4cbd01;}.cls-3{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.41,
    y: 8.21,
    width: 9.52,
    height: 11.51
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46673",
    "data-name": "Path 46673",
    className: "cls-2",
    d: "M16.43,0a.92.92,0,0,0-.92.91h0v.92a.91.91,0,0,0,.91.91h9.14V8.66A1.36,1.36,0,0,0,26.94,10l5.91,0v26a1.33,1.33,0,0,1-1.3,1.37h-21a1.34,1.34,0,0,1-1.37-1.31V34.68a.91.91,0,0,0-.91-.91H7.3a.9.9,0,0,0-.91.9h0v1.37a4.12,4.12,0,0,0,4.1,4.1h21a4.13,4.13,0,0,0,4.11-4.1V8.23a1.4,1.4,0,0,0-.4-1L28.34.4a1.41,1.41,0,0,0-1-.4Zm-10,19.16a.91.91,0,0,0,.91.92h.91a.92.92,0,0,0,.92-.91h0V10a.91.91,0,0,0-.91-.91H7.3a.91.91,0,0,0-.91.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46674",
    "data-name": "Path 46674",
    className: "cls-2",
    d: "M10.5,0A4.13,4.13,0,0,0,6.39,4.11V6.39a.91.91,0,0,0,.91.91h.91a.91.91,0,0,0,.92-.91h0V4.11a1.33,1.33,0,0,1,1.3-1.37h2.35a.91.91,0,0,0,.91-.91h0V.91A.91.91,0,0,0,12.78,0H10.5ZM1.83,21.9A1.82,1.82,0,0,0,0,23.72H0v6.39a1.82,1.82,0,0,0,1.82,1.82H21a1.82,1.82,0,0,0,1.82-1.81h0V23.73A1.82,1.82,0,0,0,21,21.9H1.83Zm2.7,2.5H6.29C7.69,24.4,8.4,25,8.4,26s-.7,1.66-2.11,1.66H5.57v.87H6c.35,0,.52.12.52.47s-.17.47-.52.47H4.54c-.35,0-.53-.12-.53-.47a.43.43,0,0,1,.37-.47h.16V25.34H4.48A.42.42,0,0,1,4,25v-.1c0-.34.18-.47.53-.47Zm5.06,0h1.05a4,4,0,0,1,2,.33,2.44,2.44,0,0,1,1.06,2.19,3.47,3.47,0,0,1-.06.64,2.18,2.18,0,0,1-1.14,1.63,3.42,3.42,0,0,1-1.64.26H9.59c-.36,0-.54-.12-.54-.47a.43.43,0,0,1,.37-.47h.17V25.34H9.52A.42.42,0,0,1,9.05,25v-.1c0-.34.18-.47.54-.47Zm5.29,0h3.48c.36,0,.45.09.45.39v.95c0,.37-.13.54-.47.54s-.45-.18-.45-.54V25.3h-2v1.09h.74v-.05c0-.32.15-.48.44-.48s.44.18.44.53v.88c0,.36-.12.53-.44.53a.39.39,0,0,1-.44-.45v-.08h-.74v1.25h.24c.35,0,.52.11.52.46s-.17.47-.52.47H14.88c-.35,0-.53-.12-.53-.47a.42.42,0,0,1,.37-.46h.16V25.35h-.06a.43.43,0,0,1-.47-.37v-.1c0-.34.18-.47.53-.47Zm-3.94.92a1,1,0,0,0-.25,0v3.18h.24c1.07,0,1.56-.5,1.56-1.6s-.5-1.6-1.55-1.6Zm-5.37.06v1.31h.6c.67,0,1-.24,1-.67s-.34-.64-1-.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1370-2",
    "data-name": "Group 1370-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46675",
    "data-name": "Path 46675",
    className: "cls-2",
    d: "M19.17,19.72a.79.79,0,0,1-.56-.23l-4-4a.78.78,0,0,1,0-1.1l.46-.46a.75.75,0,0,1,.56-.23.71.71,0,0,1,.55.23L18,15.74V8.93a.68.68,0,0,1,.23-.52.85.85,0,0,1,.55-.2h.79a.87.87,0,0,1,.55.2.68.68,0,0,1,.23.52v6.81L22.14,14a.76.76,0,0,1,1.08,0h0l.45.46a.77.77,0,0,1,0,1.09l0,0-4,4a.74.74,0,0,1-.55.23"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/pdf-download.7cf7b48dac6340c7e0b186b29711d374.svg";
export { ForwardRef as ReactComponent };